/**
 * Loại Nộp kinh phí
 */
export default {
  // Bảo hiểm
  Insurance: 1,
  // KPCĐ
  LaborUnion: 2,
};
